module.exports = __webpack_public_path__ + "static/img/va-banner-d.25f3d80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/va-banner-d.png
// module id = DRAn
// module chunks = 1